module.exports = {
  'cap': false,
  'curry': false,
  'fixed': false,
  'immutable': false,
  'rearg': false
};



//////////////////
// WEBPACK FOOTER
// ../node_modules/lodash/fp/_falseOptions.js
// module id = 44
// module chunks = 0